import axios from 'axios';
import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';
import { IAppContext } from '../../context/DefaultAppState';
import { Link } from 'react-router-dom';
import styles from './TherapeuticClassList.module.scss';
import { transformStringForURI } from '../../lib/util';

const TherapeuticClassList = () => {
  const appContext = useContext(AppContext);
  const history = useHistory();
  useEffect(() => initializeClassList(appContext), []);
  return (
    <>
      <h2 className={styles.letterTitle}>Therapeutic Class</h2>
      <div className="index-list">
        {appContext.therapeuticList.map((x, i) => (
          <div className={styles.listItem} key={`tl-${i}`}>
            <Link to={`/therapeutic/${appContext.plan?.formularyTier}/${transformStringForURI(x)}`}>
              {x}
            </Link>
          </div>
        ))}
      </div>
    </>
  );
};

const initializeClassList = (appContext: IAppContext) => {
  (async () => {
    const tier = appContext.plan?.formularyTier;
    const reportYear = appContext.selectedYear;
    if (!tier || !reportYear) return;
    const { data } = await axios.get(`/Drugs/${tier}/${reportYear}/Category`);
    appContext.updateTherapeuticList(data);
  })();
};

export default TherapeuticClassList;